// Function to update the quantity display
// eslint-disable-next-line require-jsdoc
function updateQuantity(quantity) {
    var newQuantity = parseInt(quantity, 10);

    if (isNaN(newQuantity) || newQuantity < 1) {
        newQuantity = 1;
    }

    // Update the quantity display
    $('.quantity-select').val(newQuantity);
    $('.js-qty-text').text(newQuantity);
}
module.exports = {
    qtyMinus: function () {
        $('.js-minus').on('click', function () {
            var quantity = parseInt($('.js-qty-text').text(), 10);
            if (quantity > 1) {
                quantity--;
                updateQuantity(quantity);
            }
        });
    },
    qtyPlus: function () {
        $('.js-plus').on('click', function () {
            var quantity = parseInt($('.js-qty-text').text(), 10);
            quantity++;
            updateQuantity(quantity);
        });
    }
};
